



















































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeOrcamentoStore from '@/components/Backoffice/Store/BackofficeOrcamentoStore'
import EventBus from '@/plugins/EventBus'

@Component
export default class ComponentModalBackofficeCancelarOrcamento extends Vue {
  $refs!: {
    motivoCancelamentoOrcamentoForm: any
  }

  motivoCancelamentoOrcamentoRules: any = {
    valid: true,
    motivoCancelamentoId: [(v: any) => !!v || 'Campo obrigatório'],
  }

  get getBackofficeOrcamentoStore() {
    return getModule(BackofficeOrcamentoStore, this.$store)
  }

  get motivoCancelamentoId() { return this.getBackofficeOrcamentoStore.motivoCancelamentoId }
  set motivoCancelamentoId(value: string) { this.getBackofficeOrcamentoStore.setMotivoCancelamentoId(value) }

  get showModalCancelamento() { return this.getBackofficeOrcamentoStore.showModalCancelamento }
  set showModalCancelamento(value: boolean) { this.getBackofficeOrcamentoStore.setShowModalCancelamento(value) }

  @Watch('showModalCancelamento')
  onChangeShowModalCancelamento(value: boolean) {
    if (!value) {
      this.getBackofficeOrcamentoStore.clearMotivoCancelamentoId()
      this.getBackofficeOrcamentoStore.clearOrcamentoId()
      this.$refs.motivoCancelamentoOrcamentoForm.resetValidation()
      this.$refs.motivoCancelamentoOrcamentoForm.reset()
    }
  }

  loadingCancelar: boolean = false

  async backofficeCancelaOrcamentoParticular() {
    if (!this.$refs.motivoCancelamentoOrcamentoForm.validate()) return

    this.loadingCancelar = true

    const response = await this.getBackofficeOrcamentoStore.backofficeCancelaOrcamentoParticular()

    if (!response.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message ? `${response.message} ${String.fromCodePoint(0x1F615)}` : `Ocorreu um erro ao cancelar o orçamento ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingCancelar = false
      return
    }

    await this.getBackofficeOrcamentoStore.loadAgendamentosMedicoSearch()

    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Orçamento cancelado com sucesso! ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })

    this.loadingCancelar = false
    this.showModalCancelamento = false
  }
}
